// extracted by mini-css-extract-plugin
module.exports = {"section":"Wrapper_section__2IxpE"};